<div class="container-fluid">

  <!-- Map Section -->
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center" style="background-color: #B71C1C; color: white;">
          <h5 class="card-title mb-0" style="color: white;">
            <i class="ri-map-pin-line me-2"></i>Location Map
          </h5>
        </div>
        <div class="card-body p-0">
          <div id="assignment-map" style="height: 600px; width: 100%;"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Map Legend -->
  <div class="row mt-3">
    <div class="col-12">
      <div class="card">
        <div class="card-header" style="background-color: #B71C1C; color: white;">
          <h6 class="card-title mb-0" style="color: white;">
            <i class="ri-compass-line me-2"></i>Map Legend
          </h6>
        </div>
        <div class="card-body">
          <div class="row map-legend">
            <!-- <div class="col-md-4">
              <div class="legend-item">
                <img src="assets/icons/incident-marker.svg" style="width: 32px; height: 32px; margin-right: 10px;" alt="Incident">
                <span>Incident Location</span>
              </div>
            </div> -->
            <div class="col-md-4">
              <div class="legend-item">
                <img src="assets/icons/fire-station-marker.svg" style="width: 32px; height: 32px; margin-right: 10px;" alt="Fire Station">
                <span>Fire Station</span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="legend-item">
                <img src="assets/icons/vehicle-marker.svg" style="width: 28px; height: 28px; margin-right: 10px;" alt="Vehicle">
                <span>Vehicles</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


